/**
 * @file CarrierDeliverySyncField.tsx
 * @description Период автоопроса статусов доставки (phase19.13 шаг 4).
 *
 * Второй канал получения статусов помимо вебхука: перевозчик иногда теряет
 * push, и без опроса отгрузка «залипает» в старом этапе. Ноль означает
 * «опрос выключен» — это осознанный выбор магазина, а не пустое поле.
 */

import { Input } from "../ui/input";
import { Label } from "../ui/label";

interface Props {
  /** Минуты; 0 — автоопрос выключен. Строкой, чтобы поле можно было очистить. */
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function CarrierDeliverySyncField({ value, onChange, disabled }: Props) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label
        htmlFor="deliverySyncIntervalMinutes"
        className="text-xs font-semibold tracking-wide uppercase text-on-surface-variant"
      >
        Статусы доставки
      </Label>
      <Input
        id="deliverySyncIntervalMinutes"
        inputMode="numeric"
        className="sm:max-w-xs"
        placeholder="60"
        aria-label="Автоопрос статусов, минут"
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      />
      <p className="text-xs text-on-surface-variant">
        Автоопрос статусов, минут. 0 — выключен; статусы приходят только по вебхуку.
      </p>
    </div>
  );
}
